import { clsx } from 'clsx'
import { ExclamationCircleIcon } from '@heroicons/react/24/outline'

interface Props {
  size?: 'xs' | 'sm'
  message?: string
}

const FraudCheckNotice = ({ size = 'sm', message }: Props = {}) => (
  <p className="mb-0 flex">
    <ExclamationCircleIcon
      className={clsx('shrink-0 text-teal-green', {
        'size-6': size == 'sm',
        'size-5': size == 'xs',
      })}
    />
    &nbsp;
    <span
      className={clsx({
        'pt-1 text-sm': size == 'sm',
        'pt-0.5 text-xs': size == 'xs',
      })}
    >
      <span className="font-semibold text-teal-green">Please note:</span>
      &nbsp;{message ?? 'this item will require proof of identity at checkout'}
    </span>
  </p>
)

export default FraudCheckNotice
